import request from '@/utils/request';

/**
 * 沃尔玛自由兑 - 保存配置
 * @param {*} data
 * @returns
 */
export function saveWoermaChannelCategory(data) {
  return request({
    url: '/orders/channel-profig-rate-config/save-woerma-channel-category',
    method: 'post',
    data: data
  });
}

/**
 * 大润发扫码购-保存企业组配置
 * @param {*} data
 * @returns
 */
export function saveDrfSmgCompanyCodeConfig(data) {
  return request({
    url: '/orders/channel-profig-rate-config/save-drf-smg-company-code-config',
    method: 'post',
    data: data
  });
}

/**
 * 营销参数管理 - 获取初始值
 * @param {*} params
 * @returns
 */
export function getRateConfigList(params) {
  return request({
    url: '/orders/channel-profig-rate-config/list',
    method: 'get',
    params: params
  });
}
/**
 * 营销参数管理 - 更新值
 * @param {*} data
 * @returns
 */
export function upRateConfig(data) {
  return request({
    url: '/orders/channel-profig-rate-config/up',
    method: 'post',
    data: data
  });
}

/**
 * 营销参数管理 - 保存超市关键字过滤配置
 * @param {*} data
 * @returns
 */
export function saveSupermarketKeywordFilter(data) {
  return request({
    url: '/orders/channel-profig-rate-config/save-supermarket-keyword-filter',
    method: 'post',
    data: data
  });
}

// 用户信息 - 获取渠道用户信息列表
export function getUserList(params) {
  return request({
    url: '/user/channel-user/channel-user-list',
    method: 'get',
    params: params
  });
}
// 用户信息 - 获取渠道用户绑卡信息
export function getUserCardList(params) {
  return request({
    url: '/user/channel-user/channel-user-card-list',
    method: 'get',
    params: params
  });
}
// 用户信息 - 获取渠道用户登录流水
export function getUserLoginLog(params) {
  return request({
    url: '/user/channel-user/channel-user-login-log',
    method: 'get',
    params: params
  });
}
// 获取余额预警设置
export function getAlertSettings(params) {
  return request({
    url: '/balance/balance-channel/forewarning',
    method: 'get',
    params: params
  });
}
// 余额预警设置保存
export function saveAlertSettings(data) {
  return request({
    url: '/balance/balance-channel/forewarning',
    method: 'post',
    data: data
  });
}
// 系统帮助左侧列表
export function getSystemHelpLeftList(params) {
  return request({
    url: '/orders/knowledge/system-help',
    method: 'get',
    params: params
  });
}
// 系统帮助右侧列表
export function getSystemHelpRightList(params) {
  return request({
    url: '/orders/knowledge/list',
    method: 'get',
    params: params
  });
}
// 系统帮助数据详情
export function getSystemHelpShowDetail(params) {
  return request({
    url: '/orders/knowledge/show',
    method: 'get',
    params: params
  });
}
// 销售工具左侧菜单
export function getCardSystemHelpLeftList(params) {
  return request({
    url: '/orders/knowledge/knowledge-base',
    method: 'get',
    params: params
  });
}
// 分配目录权限
export function getKnowledgeAuthList(params) {
  return request({
    url: '/orders/knowledge-catalogue/data-auth',
    method: 'get',
    params: params
  });
}
// 余额变动日报
export function getDetailDayLog(params) {
  return request({
    url: '/balance/balance-channel/detail-day-log',
    method: 'get',
    params: params
  });
}
// 获取短信每日账单
export function getSmsBillDaily(params) {
  return request({
    url: '/customer/channel-sms-bill/get-sms-bill-daily',
    method: 'get',
    params: params
  });
}
// 导出短信每日账单
export function exportSmsBillDaily(params) {
  return request({
    url: '/customer/channel-sms-bill/export-sms-bill-daily',
    method: 'get',
    params: params
  });
}
// 获取短信账单明细搜索项
export function getBillDetailSearch(params) {
  return request({
    url: '/customer/channel-sms-bill/get-bill-detail-search',
    method: 'get',
    params: params
  });
}
// 获取短信账单明细
export function getSmsBillDetail(params) {
  return request({
    url: '/customer/channel-sms-bill/get-sms-bill-detail',
    method: 'get',
    params: params
  });
}
// 导出短信账单明细
export function exportSmsBillDetail(params) {
  return request({
    url: '/customer/channel-sms-bill/export-sms-bill-detail',
    method: 'get',
    params: params
  });
}
// 添加组织
export function addOrganize(params) {
  return request({
    url: '/orders/organize/add',
    method: 'get',
    params: params
  });
}
// 编辑组织
export function updateOrganize(params) {
  return request({
    url: '/orders/organize/update',
    method: 'get',
    params: params
  });
}
// 删除组织
export function delOrganize(params) {
  return request({
    url: '/orders/organize/del',
    method: 'get',
    params: params
  });
}
// 获取员工
export function getKnowledgeCatalogueList(params) {
  return request({
    url: '/orders/knowledge-catalogue/get-user',
    method: 'get',
    params: params
  });
}
// 用户信息-高级设置
export function userSet(data) {
  return request({
    url: '/user/channel-movie-risk/user-mobile',
    method: 'post',
    data: data
  });
}
// 用户信息-获取高级设置
export function getUserSet(params) {
  return request({
    url: '/user/channel-movie-risk/user-config',
    method: 'get',
    params: params
  });
}
// 对账单搜索
export function getSearchTypes(params) {
  return request({
    url: '/balance/self-reconciliation/search-types',
    method: 'get',
    params: params
  });
}
// 对账单列表
export function getReconciliationList(params) {
  return request({
    url: '/balance/self-reconciliation/lists',
    method: 'get',
    params: params
  });
}
// 确认对账单
export function confirmReconciliation(params) {
  return request({
    url: '/balance/self-reconciliation/confirm',
    method: 'get',
    params: params
  });
}
// 对账单导出
export function reconciliationExport(params) {
  return request({
    url: '/balance/self-reconciliation/export',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}
// 对账单详情上方数据
export function getReconciliationDetailTop(params) {
  return request({
    url: '/balance/self-reconciliation/detail',
    method: 'get',
    params: params
  });
}
// 开票明细
export function getInvoiceList(params) {
  return request({
    url: '/balance/self-reconciliation/get-invoice-lists',
    method: 'get',
    params: params
  });
}
// 交易明细
export function getBalanceDetailInfoLog(params) {
  return request({
    url: '/balance/balance-channel/detail-info-log',
    method: 'get',
    params: params
  });
}
// 交易类型列表
export function selfTransactionTypeList(params) {
  return request({
    url: '/balance/self-reconciliation/get-trading-lists',
    method: 'get',
    params: params
  });
}
// 对账单明细导出
export function getBalanceInfoLogExport(params) {
  return request({
    url: '/balance/balance-channel/detail-info-log-export',
    method: 'get',
    params: params
  });
}
// 搜索框数据
export function getBalanceSearchTypesV2(params) {
  return request({
    url: '/balance/balance-channel/search-types-v2',
    method: 'get',
    params: params
  });
}
// 批量移除
export function balanceBatchRemoveInvoice(params) {
  return request({
    url: '/balance/self-reconciliation/batch-remove-invoice',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}

// 渠道-获取高级设置
export function getAdvancedSetting(params) {
  return request({
    url: '/user/channel/advanced-setting-self',
    method: 'get',
    params: params
  });
}
//  渠道-保存高级设置
export function saveAdvancedSetting(data) {
  return request({
    url: '/user/channel/save-advanced-setting-self',
    method: 'post',
    data: data
  });
}
// 获取白名单列表
export function getChannelRiskList(params) {
  return request({
    url: '/user/channel-risk/index-self',
    method: 'get',
    params: params
  });
}
// 创建白名单
export function createChannelRisk(data) {
  return request({
    url: '/user/channel-risk/create-self',
    method: 'post',
    data: data
  });
}
// 编辑白名单
export function updateChannelRisk(data) {
  return request({
    url: '/user/channel-risk/update-self',
    method: 'post',
    data: data
  });
}
// 移除白名单
export function delChannelRisk(params) {
  return request({
    url: '/user/channel-risk/delete-self',
    method: 'get',
    params: params
  });
}
// 渠道列表-高级设置-查看例外
export function getException(params) {
  return request({
    url: '/user/channel-movie-risk/mobile-index-self',
    method: 'get',
    params: params
  });
}
// 渠道列表-高级设置-查看例外-添加配置
export function addException(data) {
  return request({
    url: '/user/channel-movie-risk/mobile-create-self',
    method: 'post',
    data: data
  });
}
// 渠道列表-高级设置-查看例外-更新配置
export function updateException(data) {
  return request({
    url: '/user/channel-movie-risk/mobile-update-self',
    method: 'post',
    data: data
  });
}
// 渠道列表-高级设置-查看例外-配置-删除
export function mobileDelete(params) {
  return request({
    url: 'user/channel-movie-risk/mobile-delete-self',
    method: 'get',
    params: params
  });
}

// 获取卡类型列表
export function getSpecialCardTypeList(params) {
  return request({
    url: '/orders/special-card-bin/index',
    method: 'get',
    params: params
  });
}
// 获取提成信息
export function getSpecialProportion(params) {
  return request({
    url: '/orders/special-card-bin/get-proportion',
    method: 'get',
    params: params
  });
}
// 获取卡类型数据
export function getSpecialCardTypeData(data) {
  return request({
    url: '/orders/special-card-bin/get-cardbin',
    method: 'post',
    data: data
  });
}
// 添加卡类型
export function specialCardBinAdd(data) {
  return request({
    url: '/orders/special-card-bin/add',
    method: 'post',
    data: data
  });
}
// 编辑卡类型

export function specialUpCardbin(data) {
  return request({
    url: '/orders/special-card-bin/up-cardbin',
    method: 'post',
    data: data
  });
}
// 删除提成
export function deleteSpecialCommission(params) {
  return request({
    url: '/orders/special-card-bin/del',
    method: 'get',
    params: params
  });
}
// 添加卡类型
export function addSpecialCardBin(data) {
  return request({
    url: '/orders/special-card-bin/add',
    method: 'post',
    data: data
  });
}
// 添加提成
export function addSpecialProportion(data) {
  return request({
    url: '/orders/special-card-bin/add-proportion',
    method: 'post',
    data: data
  });
}
// 更新提成信息
export function updateSpecialProportion(params) {
  return request({
    url: '/orders/special-card-bin/up-proportion',
    method: 'get',
    params: params
  });
}
// 管理中心-账户余额-获取短信设置
export function getSmsStting(params) {
  return request({
    url: '/balance/balance-channel/sms-setting',
    method: 'get',
    params: params
  });
}
// 管理中心-账户余额-保存短信配置
export function saveSmsStting(data) {
  return request({
    url: '/balance/balance-channel/sms-setting',
    method: 'post',
    data: data
  });
}
// 商城管理-用户信息增加删除
export function changeUserStatus(data) {
  return request({
    url: '/user/channel-user/change-user-status',
    method: 'post',
    data: data
  });
}
// 获取管理者
export function channelOrganizeUserList(params) {
  return request({
    url: '/orders/channel-organize/user-list',
    method: 'get',
    params: params
  });
}
// 交易明细
export function newGetBalanceDetailInfoLog(params) {
  return request({
    url: '/balance/self-reconciliation/detail-info-log',
    method: 'get',
    params: params
  });
}
// 获取品牌列表 - 在线点单
export function getOnlineFoodsBrandList(params) {
  return request({
    url: '/orders/channel-profig-rate-config/online-foods-brand-list',
    method: 'get',
    params: params
  });
}
// 在线点单 保存品牌
export function saveOnlineFoodsBrand(data) {
  return request({
    url: '/orders/channel-profig-rate-config/online-foods-rate-save',
    method: 'post',
    data: data
  });
}
// 在线点单 删除品牌
export function delOnlineFoodsBrand(data) {
  return request({
    url: '/orders/channel-profig-rate-config/online-foods-rate-del',
    method: 'post',
    data: data
  });
}
// 商城管理-用户信息-获取购物车信息
export function getShoppingCar(params) {
  return request({
    url: '/user/card-info/cart',
    method: 'get',
    params: params
  });
}
// 商城管理-用户信息-删除购物车
export function removeShoppingCar(params) {
  return request({
    url: '/user/card-info/cart-del',
    method: 'get',
    params: params
  });
}
// 商城管理-用户信息-购物车-商城更新购物车
export function cartShopUpdateNum(params) {
  return request({
    url: '/user/card-info/cart-shop-update-num',
    method: 'get',
    params: params
  });
}
// 商城管理-用户信息-购物车-自足礼包更新购物车
export function cartPackageSelfUpdateNum(params) {
  return request({
    url: '/user/card-info/cart-package-self-update-num',
    method: 'get',
    params: params
  });
}
// 商城管理-用户信息-购物车-自组礼包更新购物车
export function cartPackageUpdateNum(params) {
  return request({
    url: '/user/card-info/cart-package-update-num',
    method: 'get',
    params: params
  });
}
// 商城管理-用户信息-购物车-礼包购物车更新
export function cartPackageBatchUpdateNum(params) {
  return request({
    url: '/user/card-info/cart-package-batch-update-num',
    method: 'get',
    params: params
  });
}
// 商城管理-用户信息-清除用户登录状态
export function clearLoginStatus(params) {
  return request({
    url: '/user/card-info/sign-out',
    method: 'get',
    params: params
  });
}
// 保存vp 审核
export function setVpAuditUser(params) {
  return request({
    url: '/orders/organize/set-vp-audit-user',
    method: 'get',
    params: params
  });
}
// 获取所属城市
export function getCityList(params) {
  return request({
    url: '/orders/organize/city-list',
    method: 'get',
    params: params
  });
}
/**
 * 营销管理 获取渠道级设置信息
 * @param {*} params
 * @returns
 */
export function getMovieSetting(params) {
  return request({
    url: '/user/channel/get-movie-settings',
    method: 'get',
    params: params
  });
}
/**
 * 营销管理 设置渠道级设置信息
 * @param {*} data
 * @returns
 */
export function setMovieSetting(data) {
  return request({
    url: '/user/channel/set-movie',
    method: 'post',
    data: data
  });
}
/**
 * 管理中心-营销参数-在线点单-服务提示配置
 * @param {*} data
 * @returns
 */
export function saveOnlineTips(data) {
  return request({
    url: '/orders/channel-profig-rate-config/up-goods-detail',
    method: 'post',
    data: data
  });
}
//获取上午支持数据
export function getAllBusinessUserList(params) {
  return request({
    url: '/package/package-programme/user-ids',
    method: 'get',
    params: params
  });
}
//获取选中商务
export function getBusinessUser(params) {
  return request({
    url: '/package/organize-business/index',
    method: 'get',
    params: params
  });
}
export function saveBusinessUser(data) {
  return request({
    url: '/package/organize-business/save-data',
    method: 'post',
    data: data
  });
}
// 设置领卡管理员
export function setCardManageUser(params) {
  return request({
    url: '/orders/organize/set-card-management-user',
    method: 'get',
    params: params
  });
}
// 保存电影设置
export function saveMovieSetting(data) {
  return request({
    url: '/user/channel/setting-movie-self',
    method: 'post',
    data: data
  });
}

// 保存用户绑卡设置
export function saveUserCardSetting(data) {
  return request({
    url: '/user/channel/setting-user-card-binding-self',
    method: 'post',
    data: data
  });
}

// 保存其他设置
export function saveOtherSetting(data) {
  return request({
    url: '/user/channel/setting-other-self',
    method: 'post',
    data: data
  });
}

// 保存资源条件风控设置
export function saveRiskControlSetting(data) {
  return request({
    url: '/user/channel/setting-risk-control-self',
    method: 'post',
    data: data
  });
}

// 保存订单满减券设置
export function saveOrderCouponSetting(data) {
  return request({
    url: '/user/channel/setting-order-coupon-style-self',
    method: 'post',
    data: data
  });
}
// 实体购物车强弱校验
export function saveCartSetting(data) {
  return request({
    url: '/user/channel/setting-cart-verify-self',
    method: 'post',
    data: data
  });
}
// 获取用户绑定微信设置
export function getWechatBindSetting(params) {
  return request({
    url: '/user/channel/setting-wechat-bind',
    method: 'get',
    params: params
  });
}
// 保存用户绑定微信设置
export function saveWechatBindSetting(data) {
  return request({
    url: '/user/channel/setting-wechat-bind',
    method: 'post',
    data: data
  });
}
// 获取永辉分类
export function getYonghuiCategory(params) {
  return request({
    url: '/orders/channel-profig-rate-config/get-yonghui-category',
    method: 'get',
    params: params
  });
}
// 获取永辉渠道分类
export function getYonghuiChannelCategory(params) {
  return request({
    url: '/orders/channel-profig-rate-config/get-yonghui-channel-category',
    method: 'get',
    params: params
  });
}
// 保存永辉渠道分类
export function setYonghuiChannelCategory(data) {
  return request({
    url: '/orders/channel-profig-rate-config/save-yonghui-channel-category',
    method: 'post',
    data: data
  });
}
// 获取其他物料列表
export function getOtherMaterialList(params) {
  return request({
    url: '/material/material/other-list',
    method: 'get',
    params: params
  });
}
// 创建其他物料
export function createOtherMaterial(data) {
  return request({
    url: '/material/material/other-create',
    method: 'post',
    data: data
  });
}
// 编辑物料
export function updateOtherMaterial(data) {
  return request({
    url: '/material/material/other-update',
    method: 'post',
    data: data
  });
}
// 删除其他物料
export function deleteOtherMaterial(data) {
  return request({
    url: '/material/material/other-toggle-status',
    method: 'post',
    data: data
  });
}
// 导出其他物料
export function exportOtherMaterial(params) {
  return request({
    url: '/material/material/other-export',
    method: 'get',
    params: params
  });
}
// 其他物料详情
export function getOtherMaterialDetail(params) {
  return request({
    url: '/material/material/other-view',
    method: 'get',
    params: params
  });
}
// 获取其他物料操作日志列表
export function getOtherMaterialLogList(params) {
  return request({
    url: '/material/material/other-log',
    method: 'get',
    params: params
  });
}
// 【物料管理卡券管理】卡券物料-列表
export function getCardMaterialList(params) {
  return request({
    url: '/material/material/index',
    method: 'get',
    params: params
  });
}
// 【物料管理卡券管理】卡券物料-添加
export function createCardMaterial(data) {
  return request({
    url: '/material/material/create',
    method: 'post',
    data: data
  });
}
// 【物料管理卡券管理】卡券物料-编辑
export function updateCardMaterial(data) {
  return request({
    url: '/material/material/update',
    method: 'post',
    data: data
  });
}
// 【物料管理卡券管理】卡券物料-删除/恢复
export function toggleCardStatusMaterial(data) {
  return request({
    url: '/material/material/toggle-status',
    method: 'post',
    data: data
  });
}
// 【物料管理卡券管理】卡券物料-导出
export function exportCardMaterial(params) {
  return request({
    url: '/material/material/export',
    method: 'get',
    params: params
  });
}
// 【物料管理卡券管理】卡券物料-详情
export function getCardMaterialDetail(params) {
  return request({
    url: '/material/material/view',
    method: 'get',
    params: params
  });
}
// 【物料管理卡券管理】卡券物料-日志
export function getCardMaterialLogList(params) {
  return request({
    url: '/material/material/log',
    method: 'get',
    params: params
  });
}
// 图库一级分类tabs
export function getMaterialDepotTab(params) {
  return request({
    url: '/material/material/map-depot-tab',
    method: 'get',
    params: params
  });
}
// 图库二级分类tabs
export function getMaterialDepotType(params) {
  return request({
    url: '/material/material/map-depot-type',
    method: 'get',
    params: params
  });
}
// 图库图片列表（分页）
export function getMaterialDepotList(params) {
  return request({
    url: '/material/material/map-depot-list',
    method: 'get',
    params: params
  });
}
// 【物料入库】其他物料-列表
export function getOtherMaterialInboundList(params) {
  return request({
    url: '/material/stock-in/other-list',
    method: 'get',
    params: params
  });
}
// 【物料入库】其他物料-入库&批量入库
export function createOtherMaterialInbound(data) {
  return request({
    url: '/material/stock-in/other-create',
    method: 'post',
    data: data
  });
}
// 【物料入库】其他物料-导出
export function exportOtherMaterialInbound(params) {
  return request({
    url: '/material/stock-in/other-export',
    method: 'get',
    params: params
  });
}
// 【物料入库】其他物料-详情
export function getOtherMaterialInboundDetail(params) {
  return request({
    url: '/material/stock-in/other-view',
    method: 'get',
    params: params
  });
}
// 【物料入库】卡券物料-列表
export function getCardMaterialStockInList(params) {
  return request({
    url: '/material/stock-in/list',
    method: 'get',
    params: params
  });
}
// 【物料入库】卡券物料-导出
export function exportCardMaterialStockIn(params) {
  return request({
    url: '/material/stock-in/export',
    method: 'get',
    params: params
  });
}
// 【物料入库】卡券物料-详情
export function getCardMaterialStockInDetail(params) {
  return request({
    url: '/material/stock-in/view',
    method: 'get',
    params: params
  });
}
// 【物料入库】卡券物料-入库&批量入库
export function createCardMaterialStockIn(data) {
  return request({
    url: '/material/stock-in/create',
    method: 'post',
    data: data
  });
}
// 【物料台账】其他物料台账-列表
export function getOtherMaterialLedgerList(params) {
  return request({
    url: '/material/material-ledger/other-list',
    method: 'get',
    params: params
  });
}
// 【物料台账】其他物料台账-库存流水
export function getOtherMaterialLedgerStock(params) {
  return request({
    url: '/material/material-ledger/other-stock-flow',
    method: 'get',
    params: params
  });
}
// 【物料台账】其他物料台账-导出
export function exportOtherMaterialLedger(params) {
  return request({
    url: '/material/material-ledger/other-export',
    method: 'get',
    params: params
  });
}
// 【物料台账】城市明细-列表
export function getCityMaterialLedgerList(params) {
  return request({
    url: '/material/city-detail/index',
    method: 'get',
    params: params
  });
}
//  【物料台账】城市明细-导出
export function exportCityMaterialLedger(params) {
  return request({
    url: '/material/city-detail/export',
    method: 'get',
    params: params
  });
}
// 【物料台账】城市明细-库存流水
export function getCityMaterialLedgerStock(params) {
  return request({
    url: '/material/city-detail/stock-flow',
    method: 'get',
    params: params
  });
}
// 【物料台账】城市明细-修改
export function updateCityMaterialLedger(data) {
  return request({
    url: '/material/city-detail/update',
    method: 'post',
    data: data
  });
}

// 【卡券物料台账】卡券物料台账-列表
export function getCardMaterialLedgerList(params) {
  return request({
    url: '/material/material-ledger/list',
    method: 'get',
    params: params
  });
}

// 【卡券物料台账】卡券物料台账-城市明细
export function getCardMaterialLedgerCityDetailIndex(params) {
  return request({
    url: '/material/material-ledger/city-detail-index',
    method: 'get',
    params: params
  });
}

// 【卡券物料台账】卡券物料台账-库存流水
export function getCardMaterialLedgerStockFlow(params) {
  return request({
    url: '/material/material-ledger/stock-flow',
    method: 'get',
    params: params
  });
}

// 【卡券物料台账】卡券物料台账-库存明细
export function getCardMaterialLedgerBatchList(params) {
  return request({
    url: '/material/material-ledger/batch-list',
    method: 'get',
    params: params
  });
}
// 【卡券物料台账】卡券物料台账-批量库存明细
export function getCardMaterialLedgerCodeDetail(params) {
  return request({
    url: '/material/material-ledger/code-detail',
    method: 'get',
    params: params
  });
}

// 【卡券物料台账】卡券物料台账-库存明细-调整库存
export function updateCardMaterialLedgerBatch(data) {
  return request({
    url: '/material/material-ledger/batch-list-set',
    method: 'post',
    data: data
  });
}

// 【物料入库】卡券物料库存明细-添加库存
export function addCardMaterialStock(data) {
  return request({
    url: '/material/material-ledger/add-stock',
    method: 'post',
    data: data
  });
}

// 【物料入库】卡券物料库存明细-添加库存前校验卡号段
export function checkCardCode(data) {
  return request({
    url: '/material/material-ledger/check-card-code',
    method: 'post',
    data: data
  });
}

// 【卡券物料台账】卡券物料台账-导出
export function exportCardMaterialLedger(params) {
  return request({
    url: '/material/material-ledger/export',
    method: 'get',
    params: params
  });
}

// 【卡券城市明细】卡券城市明细-列表
export function cardMaterialCityStockList(params) {
  return request({
    url: '/material/city-detail/card-stock-list',
    method: 'get',
    params: params
  });
}

// 【卡券城市明细】卡券城市明细-导出
export function cardMaterialCityStockExport(params) {
  return request({
    url: '/material/city-detail/card-stock-export',
    method: 'get',
    params: params
  });
}

// 【卡券城市明细】卡券城市明细-库存明细
export function cardMaterialCityBatchList(params) {
  return request({
    url: '/material/city-detail/card-batch-list',
    method: 'get',
    params: params
  });
}
// 【卡券城市明细】卡券城市明细-批量库存明细
export function cardMaterialCityBatchDetail(params) {
  return request({
    url: '/material/city-detail/code-detail',
    method: 'get',
    params: params
  });
}

// 【卡券城市明细】卡券城市明细-库存流水
export function cardMaterialCityStockFlow(params) {
  return request({
    url: '/material/city-detail/card-stock-flow',
    method: 'get',
    params: params
  });
}

// 【卡券城市明细】卡券城市明细-调整库存
export function updatecardMaterialCityStockSet(data) {
  return request({
    url: '/material/material-ledger/card-stock-set',
    method: 'post',
    data: data
  });
}

// 【基础配置】版面配置-列表
export function getMaterialIndexLayoutList(params) {
  return request({
    url: '/material/layout/layout-list',
    method: 'get',
    params: params
  });
}

// 【基础配置】版面配置-删除/恢复（id 正常→删除，删除→恢复）
export function updateMaterialIndexLayoutStatus(data) {
  return request({
    url: '/material/layout/layout-status',
    method: 'post',
    data: data
  });
}

// 【基础配置】版面配置-添加
export function createMaterialIndexLayout(data) {
  return request({
    url: '/material/layout/layout-create',
    method: 'post',
    data: data
  });
}

// 【基础配置】版面配置-编辑
export function updateMaterialIndexLayout(data) {
  return request({
    url: '/material/layout/layout-update',
    method: 'post',
    data: data
  });
}

// 【基础配置】版面配置-下拉选择列表
export function getMaterialLayoutSelect(params) {
  return request({
    url: '/material/layout/layout-select',
    method: 'get',
    params: params
  });
}
//【物料台账-卡券】库存流水导出
export function exportMaterialLedgerStockFlow(data) {
  return request({
    url: '/material/city-detail/card-stock-flow-export',
    method: 'post',
    data: data
  });
}
// 【物料台账 -其他物料】库存明细导出
export function exportMaterialOtherStockFlow(data) {
  return request({
    url: '/material/city-detail/other-stock-flow-export',
    method: 'post',
    data: data
  });
}

// 【物料申请】物料申请-列表
export function getMaterialApplyList(params) {
  return request({
    url: '/material/apply/list',
    method: 'get',
    params: params
  });
}

// 【物料申请】物料申请-详情
export function getMaterialApplyInfo(params) {
  return request({
    url: '/material/apply/info',
    method: 'get',
    params: params
  });
}

// 【物料申请】新建申请
export function createMaterialApply(data) {
  return request({
    url: '/material/apply/create',
    method: 'post',
    data: data
  });
}

// 【物料申请】修改申请
export function updateMaterialApply(data) {
  return request({
    url: '/material/apply/update',
    method: 'post',
    data: data
  });
}

// 【物料申请】取消申请
export function cancelMaterialApply(data) {
  return request({
    url: '/material/apply/cancel',
    method: 'post',
    data: data
  });
}

// 【物料申请】汇总列表
export function getMaterialApplySummary(params) {
  return request({
    url: '/material/apply/summary',
    method: 'get',
    params: params
  });
}

// 【物料申请】汇总取消
export function cancelMaterialApplySummary(data) {
  return request({
    url: '/material/apply/summary-cancel',
    method: 'post',
    data: data
  });
}

// 【物料申请】汇总确认详情
export function getMaterialApplySummaryDetail(params) {
  return request({
    url: '/material/apply/summary-detail',
    method: 'get',
    params: params
  });
}

// 【物料申请】汇总修改提交
export function modifyMaterialApplySummary(data) {
  return request({
    url: '/material/apply/summary-modify',
    method: 'post',
    data: data
  });
}

// 【物料申请】汇总确认提交
export function confirmMaterialApplySummary(data) {
  return request({
    url: '/material/apply/summary-confirm',
    method: 'post',
    data: data
  });
}

// 【物料申请】物料选择列表
export function getMaterialSelectList(params) {
  return request({
    url: '/material/apply/material-select',
    method: 'get',
    params: params
  });
}

// 【物料申请】仓库下拉（申请列表筛选用）
export function getMaterialApplyBranchOfficeList(params) {
  return request({
    url: '/material/city-detail/branch-office-select',
    method: 'get',
    params: params
  });
}

// 【物料申请】仓库下拉（汇总/印刷筛选用）
export function getSummaryBranchOfficeList(params) {
  return request({
    url: '/orders/card-make/branch-office-select',
    method: 'get',
    params: params
  });
}

// 【物料申请】物料印刷列表
export function getMaterialApplyPrint(params) {
  return request({
    url: '/material/apply/print',
    method: 'get',
    params: params
  });
}

// 【物料申请】制卡详情
export function getCardMakeInfo(params) {
  return request({
    url: '/material/apply/card-make-info',
    method: 'get',
    params: params
  });
}

// 【物料申请】可绑定制卡列表
export function getCardMakeList(params) {
  return request({
    url: '/material/apply/card-make-list',
    method: 'get',
    params: params
  });
}

// 【物料申请】绑定制卡
export function bindCardMake(data) {
  return request({
    url: '/material/apply/bind-card-make',
    method: 'post',
    data: data
  });
}

// 【物料申请】创建制卡
export function createCardMake(data) {
  return request({
    url: '/material/apply/create-card-make',
    method: 'post',
    data: data
  });
}